(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.removeAttribute('open');
  });

  document.querySelectorAll('.custom-product-metafields accordion-custom summary').forEach((summary) => {
    summary.addEventListener('click', (e) => {
      const target = e.currentTarget;
      document.querySelectorAll('.custom-product-metafields accordion-custom details').forEach((detail) => {
        const summary = detail.querySelector('summary');
        if(summary != target) detail.removeAttribute('open');
      });
    });
  });
})();
